import CAMHeader from "../../../components/Header/CAMHeader";
import CAMDrawer from "../../../components/LeftSideBar/CAMDrawer";
import { Box, Divider } from "@mui/material";
import InvestigatorContainer from "../../../components/contsiners/InvestigatorContainer";
import TableList from "./Table";
import DefinationPopup from "./DefinationPopup";
import MenuDefinationPopup from "./MenuDefinationPopup";
import { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as pro from "../../../redux/process/actions";
import Loader from "../../../components/Loader/loader";
import SnackBar from "../../../components/Snackbars/CustomizedSnackbars";
import BreadcrumbNav from "../header/BreadcrumbNav";
import DropdownsBar from "../header/ProductSiteUnitSelector";
import TabsNav from "../header/TabsNav";
import MultipleInput from "../../../components/Card/MultipleInput";
import debounce from "lodash.debounce";
import { hasPermission } from "../../../utils/permissions";
import {
  PERMISSION_MODULES,
  PROCESS_PERMISSIONS,
} from "../../../constants/permissions";

const Index = () => {
  const canEditDescriptionAndNotes = hasPermission(
    PERMISSION_MODULES.PROCESS,
    PROCESS_PERMISSIONS.EDIT_DESCRIPTION_AND_NOTES,
  );
  const [openDef, setOpenDef] = useState(false);
  const [openMenuPopup, setOpenMenuPopup] = useState(false);
  const rowsPerPage = 50;
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [viewData, setViewData] = useState();
  const group1 = ["active", "inactive"];
  const group2 = [];

  const tableHeaders = [
    "",
    "Unit Operation",
    "Parameter Name",
    "Unit of Measure",
    "Classes",
    "Source",
    "Data Type",
    "Status",
  ];
  const moreOptionList = ["Show", "Edit", "Copy", "Paste After", "Delete"];
  const dispatch = useDispatch();
  const rowData = useSelector((state) => state?.proReducer?.rows);
  const edited = useSelector((state) => state?.proReducer?.edited);
  const [errors, setErrors] = useState();
  const [definationTabField, setDefinationTabField] = useState({
    notes: "",
    description: "",

  });
  const [search, setSearch] = useState();
  const [debouncedSearch, setDebouncedSearch] = useState();
  const [analyticsTabField, setAnalyticsTabField] = useState({
    rulesetId: "",
    runRules: [],
    useRuleOne: false,
    limitMethod: "",
    stdevMethod: "",
    boxCoxTransform: "lambda_none",
    boxCoxValue: "",
    spec1: "",
    spec2: "",
    spec3: "",
    minYAxisRange: "",
    maxYAxisRange: "",
    displayAlias: "",
    useScientificNotation: false,
  });
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const { product, site } = useSelector(
    (state) => state.shared?.productSitesUopValues || {}
  );

  const [alertTabFields, setAlertTabFields] = useState({
    parameterName: "",
    description: "",
    parameterSource: "",
    unit: "",
    dataType: "",
    activeAlerts: false, // Add this
  });

  if (edited?.message === "added") {
    setSnack({
      open: true,
      message: "Success",
      severity: "success",
    });
  }

  useEffect(() => {
    dispatch(pro.clearResponse());

    // let params = {
    //   product_id: product?.id,
    //   site_id: site?.id,
    //   unit_op_id: unitOfOperation?.id,
    // };
    // // dispatch(pro.getProcessDropdown(params));
    // let param = {};
    // param.site_id = site?.id;
    // param.product_id = product?.id;
    // param.page = 1;
    // param.page_size = rowsPerPage;
    // dispatch(pro.getProcessList(param));
    if (site?.id) {
      callgetListData(1);
    }
  }, [dispatch, site?.id, debouncedSearch]);

  const validate = () => {
    const newErrors = {};
    if (!definationTabField.notes) newErrors.notes = "Required";
    if (!definationTabField.description) newErrors.description = "Required";
    // if (!definationTabField.parameterSource)
    //   newErrors.parameterSource = "Required";
    // if (!definationTabField.unit) newErrors.unit = "Required";
    // if (!definationTabField.dataType) newErrors.dataType = "Required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDefinationTabField((prev) => ({ ...prev, [name]: value }));
  };

  const handleViewClick = (data) => {
    setOpenDef(true);
    setViewData(data);
    const user = localStorage.getItem("userName");
    setDefinationTabField({
      notes: data?.notes || "",
      description: data?.parameter_description || "",
      parameter_id: data?.parameter_id || "",
      user:user
    })
  };

  const onUnitOpClick = (data) => {
    setOpenMenuPopup(true);
    setViewData(data);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canEditDescriptionAndNotes) return;
    if (!validate()) return;
    try {

      const res = await dispatch(pro.editFormData(definationTabField));
      setSnack({
        open: true,
        message: res.data.message || "Updated Successfully",
        severity: "success",
      });
      setOpenDef(false);
      callgetListData(1);
    } catch (error) {
      setSnack({
        open: true,
        message: error.message || "Error updating data",
        severity: "error",
      });
    }
  };

  const handleAnalyticsTabValueChange = (e) => {
    const { name, value, type, checked } = e.target;
    setAnalyticsTabField((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleRuleToggle = (ruleId) => {
    setAnalyticsTabField((prev) => ({
      ...prev,
      runRules: prev.runRules.includes(ruleId)
        ? prev.runRules.filter((id) => id !== ruleId)
        : [...prev.runRules, ruleId],
    }));
  };

  const handleLinkOpen = (data) => {
    setOpenMenuPopup(true);
  };

  const handleCheckboxChange = (option) => {
    setSelectedFilters((prevSelected) => {
      let updatedSelected = [];

      if (prevSelected.includes(option)) {
        updatedSelected = prevSelected.filter((item) => item !== option);
      } else {
        if (group1.includes(option)) {
          updatedSelected = [
            ...prevSelected.filter((item) => !group1.includes(item)),
            option,
          ];
        } else if (group2.includes(option)) {
          updatedSelected = [
            ...prevSelected.filter((item) => !group2.includes(item)),
            option,
          ];
        } else {
          updatedSelected = prevSelected;
        }
      }
      const status = updatedSelected.find((item) => group1.includes(item));
      const review_status = updatedSelected.find((item) =>
        group2.includes(item)
      );

      const params = {
        site_id: site?.id,
        product_id: product?.id,
        page: 1,
        page_size: rowsPerPage,
      };

      if (status) params.status = status;
      if (review_status) params.review_status = review_status;

      getListData(params);

      return updatedSelected;
    });
  };

  const getListData = (params) => {
    if (!site?.id) {
      return setSnack({
        open: true,
        message: "Please select a site first.",
        severity: "warning",
      });
    }
    dispatch(pro.getProcessList(params));
  };

  const handleMenuOption = (option, item) => {
    if (option === "Show") {
      handleViewClick(item);
    }
  };

  const debouncedSetValue = useMemo(
    () =>
      debounce((val) => {
        setDebouncedSearch(val);
      }, 700),
    []
  );

  const handleSearch = (e) => {
    setSearch(e.target.value);
    debouncedSetValue(e.target.value);
  };

  const callgetListData = (page) => {
    const review_status = selectedFilters.find((item) => group2.includes(item));
    const status = selectedFilters.find((item) => group1.includes(item));

    let params = {};
    if (debouncedSearch) params.search = debouncedSearch;
    params.page = page;
    params.page_size = rowsPerPage;
    params.site_id = site?.id;
    params.product_id = product?.id;
    if (status) params.status = status;
    if (review_status) params.review_status = review_status;
    getListData(params);
  };

  return (
    <Box>
      {" "}
      <CAMHeader />
      <CAMDrawer />
      <InvestigatorContainer>
        <TabsNav />
        <DropdownsBar isUnitOpHide={true} />
        <Divider sx={{ mx: 2 }} />
        <BreadcrumbNav isUnitOpHide={true} />
        <Divider sx={{ mx: 2 }} />
        {snack.open && (
          <SnackBar
            className="popup"
            handleClose={() => {
              setSnack({
                text: "",
                open: false,
                message: "",
              });
            }}
            severity={snack.severity}
            state={snack.open}
            text={snack.message}
          />
        )}
        <Box className="collapse-card-container">
          <Box>
            <MultipleInput
              text={"Parameter"}
              isButton={false}
              filterOptionsGroup1={group1}
              filterOptionsGroup2={group2}
              selectedFilters={selectedFilters}
              handleCheckboxChange={handleCheckboxChange}
              handleSearch={handleSearch}
              search={search}
            />
          </Box>
          <Box width="100%" className="custom-table-container">
            <TableList
              data={rowData || []}
              onView={handleViewClick}
              tableHeaders={tableHeaders}
              moreOption={moreOptionList}
              handleMenuOption={handleMenuOption}
              onUnitOpClick={onUnitOpClick}
            />
            {rowData?.loading && <Loader />}
            {/* <Pagination
              count={rowData?.data?.total / rowsPerPage}
              page={page}
              onChange={handlePageChange}
            /> */}
          </Box>
          <Box>
            <DefinationPopup
              open={openDef}
              onClose={() => setOpenDef(false)}
              definationTabField={definationTabField}
              onChange={handleChange}
              errors={errors}
              handleSubmit={handleSubmit}
              viewData={viewData}
              analyticsTabField={analyticsTabField}
              handleAnalyticsTabValueChange={handleAnalyticsTabValueChange}
              handleRuleToggle={handleRuleToggle}
              alertTabFields={alertTabFields}
              setAlertTabFields={setAlertTabFields}
              edited={edited}
              canEdit={canEditDescriptionAndNotes}
            />
            <MenuDefinationPopup
              open={openMenuPopup}
              onClose={() => setOpenMenuPopup(false)}
              definationTabField={definationTabField}
              onChange={handleChange}
              errors={{}}
              handleSubmit={{}}
              viewData={{}}
            />
          </Box>
        </Box>
      </InvestigatorContainer>
    </Box>
  );
};

export default Index;
